import { memo } from "react";
import { handleModal } from "../../redux/actions/modals";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CancellationConfirmModal from "./CancellationConfirmModal";
import { _commaFormatter, _kFormatter } from "../../controllers";
import dayjs from "dayjs";


const TransactionDetailsModal = ({ transactionDetails }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);

    const onHide = () => {
        dispatch(handleModal([{ "TRANSACTION_DETAILS_MODAL": false }]));
    };
    const handleCancel = () => {
        dispatch(handleModal([{ "TRANSACTION_CANCEL_CONFIRMATION_MODAL": true }]));
    };

    // const formatedDate = useMemo(() => {
    //     if (transactionDetails && Object.keys(transactionDetails).length) {
    //         return dayjs(transactionDetails?.DispDateTime, { format: "MM/DD/YYYY h:mm A" }).format("DD MMM'YY h:mm A");
    //     } else { }
    // }, [transactionDetails]);

    return (
        <Container fluid className='p-0'>

            <BzModal show={modals['TRANSACTION_DETAILS_MODAL']} onHide={onHide}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Transactions Details</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Amount</Col>
                            <Col className={`font-medium font-size1 color-text text-end ${transactionDetails.type === "W" ? "color-negative" : 'color-positive'}`}>{transactionDetails.type === "W" ? "-" : "+"} ₹ {_commaFormatter(_kFormatter(parseFloat(transactionDetails?.nAmount)))}</Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Transaction Type</Col>
                            <Col className='font-medium font-size1 color-text text-end'> {transactionDetails?.type === "AL" ? "Transferred" : transactionDetails?.type === "W" ? "Withdrawal" : "Added"}</Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Product</Col>
                            <Col className='font-medium font-size1 color-text text-end'>{transactionDetails?.sProductName}</Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Transaction Reference</Col>
                            <Col className='font-medium font-size1 color-text text-end '>{transactionDetails?.nTxnRefNo}</Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Bank Reference</Col>
                            <Col className='font-medium font-size1 color-text text-end'>{transactionDetails?.type === "A" ? transactionDetails?.sBankName : "-"}</Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Bank Name</Col>
                            <Col className='font-medium font-size1 color-text text-end'>{transactionDetails?.sBankName}</Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='font-medium font-size1 color-subtext text-start'>Date & Time</Col>
                            <Col className='font-medium font-size1 color-text text-end'>{dayjs(transactionDetails?.DispDateTime).format('DD MMM\'YY  hh:mm A')}</Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        {transactionDetails?.type === "W" && transactionDetails?.Status?.toUpperCase() === "PENDING" ?
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-center'>
                                    <BzButton className='btn btn-md btn-block btn-primary text-capitalize' onClick={() => handleCancel()}>Request Cancellation</BzButton>
                                </Col>
                            </Row>
                            : null}
                    </Container>
                </BzModalFooter>
            </BzModal>
            <CancellationConfirmModal transactionDetails={transactionDetails} />
        </Container>
    );
};

export default memo(TransactionDetailsModal);